<template>
    <div @click="gobalClick">
        <el-dialog
            v-el-drag-dialog
            :before-close="handleClose"
            :visible.sync="selectUser"
            width="45%"
            title="查看详情"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <span slot="footer" class="dialog-footer">
                <el-button @click="selectUser = false">取 消</el-button>
            </span>
        </el-dialog>
        <transition name="subname">
            <div
                @click="selfShow"
                v-show="sublistShow"
                class="subCard"
                ref="subCard"
            >
                <el-card>
                    <el-row style="padding-bottom: 12px">
                        <el-col>
                            <span style="padding: 8px 0">子表详情</span>
                            <el-button
                                type="danger"
                                icon="el-icon-close"
                                circle
                                size="mini"
                                class="pull-right"
                                @click="closeSub"
                            ></el-button>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="detailData"
                        size="mini"
                        style="width: 100%"
                        border
                    >
                        <el-table-column label="门店名称">
                            <template slot-scope="scope">{{
                                scope.row.shopName
                            }}</template>
                        </el-table-column>
                        <el-table-column label="门店编码">
                            <template slot-scope="scope">{{
                                scope.row.shopCode
                            }}</template>
                        </el-table-column>

                        <el-table-column
                            prop="paywayId"
                            label="支付方式编码"
                        ></el-table-column>
                        <el-table-column
                            prop="paywayName"
                            label="支付方式"
                        ></el-table-column>
                        <el-table-column
                            prop="payMoney"
                            label="支付金额"
                        ></el-table-column>
                    </el-table>
                </el-card>
            </div>
        </transition>
        <div
            class="padding7 el-card"
            v-loading="openloading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
            :element-loading-text="loadingText"
        >
            <el-form
                :model="voucherQueryModel"
                label-width="120px"
                label-position="left"
            >
                <div>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item
                                label="品牌"
                                label-width="80px"
                                :required="true"
                            >
                                <el-select
                                    v-model="voucherQueryModel.brandId"
                                    placeholder="选择品牌"
                                    size="mini"
                                    class="width100"
                                    @change="brandChange"
                                    filterable
                                >
                                    <el-option
                                        v-for="item in brandList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item
                                label="门店"
                                label-width="80px"
                                :required="true"
                            >
                                <el-select
                                    v-model="voucherQueryModel.store"
                                    placeholder="选择门店"
                                    size="mini"
                                    class="width100"
                                    @change="storeChange"
                                    filterable
                                    multiple
                                    @remove-tag="removeTag"
                                >
                                    <el-option
                                        label="全选"
                                        value="全选"
                                    ></el-option>
                                    <el-option
                                        v-for="item in storesList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item
                                label="制单日期"
                                label-width="80px"
                                :required="true"
                            >
                                <el-date-picker
                                    v-model="time"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                    @change="timeChange"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12" class="top7">
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-setting"
                                class="pull-left"
                                @click="SetFilters"
                                :disabled="!brandSel"
                                >过滤源数据</el-button
                            >
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-search"
                                class="pull-left"
                                @click="search(false)"
                                :disabled="!storeSel"
                                >查询</el-button
                            >
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="会员数据在第一次拉取后已本地化缓存，若需更新数据，请使用重新拉取操作"
                                placement="top-start"
                            >
                                <el-button
                                    type
                                    size="mini"
                                    class="pull-left"
                                    icon="el-icon-download"
                                    @click="search(true)"
                                    :disabled="!storeSel"
                                    >重新拉取</el-button
                                >
                            </el-tooltip>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item label="生成方式" label-width="80px">
                                <el-select
                                    v-model="voucherQueryModel.groupType"
                                    placeholder="选择凭证生成方式"
                                    size="mini"
                                    class="width100"
                                >
                                    <el-option
                                        v-for="item in voucherTypeList"
                                        :key="item.number"
                                        :label="item.name"
                                        :value="item.number"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="6">
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-download"
                                class="pull-left"
                                @click="voucherCreateShow"
                                :disabled="!isSearchVal"
                                >生成凭证</el-button
                            >
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <el-table
                :data="tableData"
                ref="tableData"
                size="mini"
                style="width: 100%"
                border
                @row-click="clickRow"
            >
                <el-table-column label="起止日期" width="200">
                    <template slot-scope="scope">
                        <span
                            :class="scope.row.color"
                            style="margin-right: 10px"
                        ></span>
                        {{ dateFormat(scope.row.startTime) }}/{{
                            dateFormat(scope.row.endTime)
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="shopName" label="门店"></el-table-column>
                <el-table-column
                    prop="shopCode"
                    label="门店编码"
                ></el-table-column>

                <el-table-column
                    prop="consumeAmount"
                    label="账单消费"
                ></el-table-column>
                <el-table-column
                    prop="consumeBz"
                    label="消费本金"
                ></el-table-column>
                <el-table-column
                    prop="rechargeAmountB"
                    label="充值本金"
                ></el-table-column>
                <el-table-column
                    prop="rechargeAmountZ"
                    label="充值赠送"
                ></el-table-column>
                <el-table-column
                    prop="consumeCz"
                    label="消费储值"
                ></el-table-column>
                <el-table-column
                    prop="consumeZs"
                    label="消费赠送"
                ></el-table-column>
                <el-table-column
                    prop="consumeScore"
                    label="积分消费"
                ></el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="VoucherDataApi"
                :GetData="getTableData"
                :queryParam="queryParam"
                :isInit="false"
                :errorFunc="errorHandler"
            ></pagerBar>
            <crmStep ref="voucherCreateStep"></crmStep>
            <el-dialog
                width="30%"
                :visible.sync="SetFiltersVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="true"
                title="过滤源数据"
            >
                <div
                    class="clearfix"
                    style="padding-bottom: 6px; margin-top: -25px"
                >
                    <el-button
                        class="pull-right"
                        type="primary"
                        icon="el-icon-check"
                        size="mini"
                        @click="saveFilterData"
                        >保存</el-button
                    >
                    <el-button
                        class="pull-right right-20"
                        icon="el-icon-plus"
                        size="mini"
                        @click="addFilters()"
                        >新增行</el-button
                    >
                </div>
                <el-row :gutter="20">
                    <el-table
                        :data="filtersData"
                        size="mini"
                        ref="filtersDetail"
                        border
                        highlight-current-row
                        highlight-hover-row
                        class="toggletable"
                    >
                        <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            fixed
                        ></el-table-column>
                        <el-table-column
                            label="删除"
                            width="70"
                            fixed
                            style="margin-left: -8px"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    size="mini"
                                    @click="
                                        deleteRow(scope.$index, scope.row._id)
                                    "
                                ></el-button>
                            </template>
                        </el-table-column>
                        <template v-for="(item, index) in fieldList">
                            <el-table-column
                                :label="item.fieldName + '字段'"
                                min-width="100"
                            >
                                <template slot-scope="scope">
                                    <el-select
                                        v-model="
                                            scope.row[item.fieldName + '字段']
                                        "
                                        placeholder="请选择字段"
                                        size="mini"
                                        class="width60 floatleft"
                                        clearable
                                    >
                                        <el-option value="编码">编码</el-option>
                                        <el-option value="名称">名称</el-option>
                                    </el-select>
                                    <el-select
                                        v-model="
                                            scope.row[item.fieldName + '操作']
                                        "
                                        placeholder="请选择操作"
                                        size="mini"
                                        class="width60 floatleft"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in OperTypeList"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                    <el-input
                                        v-model="
                                            scope.row[item.fieldName + '值']
                                        "
                                        size="mini"
                                        class="width60 floatleft"
                                        placeholder="请输入值"
                                    ></el-input>
                                    <br />
                                    <span
                                        v-if="
                                            scope.row[
                                                item.fieldName + '字段'
                                            ] &&
                                            scope.row[
                                                item.fieldName + '操作'
                                            ] &&
                                            scope.row[item.fieldName + '值']
                                        "
                                        >{{ item.fieldName }}：{{
                                            scope.row[item.fieldName + '字段']
                                        }}
                                        ->
                                        {{ scope.row[item.fieldName + '操作'] }}
                                        ->
                                        {{
                                            scope.row[item.fieldName + '值']
                                        }}</span
                                    >
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </el-row>
            </el-dialog>
            <!-- <el-dialog
                :visible.sync="Visible"
                title="凭证生成"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                show-close
                append-to-body
            >
                <div class="el-dialog__body" v-if="step2errormsg.length > 0">
                    凭证生成详细结果：
                    <el-table
                        :data="step2errormsg"
                        size="mini"
                        border
                        :highlight-current-row="true"
                        class="toggletable"
                        ref="detail"
                        id="out-table1"
                    >
                        <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            fixed
                        ></el-table-column>
                        <el-table-column
                            label="门店编码"
                            prop="shopCode"
                            min-width="50"
                            fixed
                        ></el-table-column>
                        <el-table-column
                            label="门店名称"
                            prop="shopName"
                            min-width="60"
                            fixed
                        ></el-table-column>
                        <el-table-column
                            label="结果"
                            prop="voucherResult"
                            class="text-wrapper"
                            min-width="120"
                            fixed
                        ></el-table-column>
                    </el-table>
                </div>
            </el-dialog> -->
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
import crmStep from './voucherCreateCrmStep'

export default {
    data() {
        return {
            fieldTypeList: ['名称', '编码'],
            OperTypeList: ['等于', '不等于'],
            fieldList: [{ fieldName: '会员结算方式' }],
            filtersData: [],
            SetFiltersVisible: false,
            DeleteFiltersUrl:
                config.BASE_Middle_API + 'VoucherCreate/DeleteFilterData',
            SaveFiltersUrl:
                config.BASE_Middle_API + 'VoucherCreate/CreateOrUpdateList',
            GetFiltersDataUrl:
                config.BASE_Middle_API + 'VoucherCreate/GetFiltersData',

            voucherTypeList: [
                { number: '1', name: '按照营业日期生成凭证' },
                { number: '2', name: '按照选择日期合并生成一张凭证' }
            ],
            step2errormsg: [],
            Visible: false,
            loadingText: '加载中',
            openloading: false,
            sublistShow: false, //子表默认隐藏,
            selectUser: false,
            isSearchVal: false,
            isVoucherCreate: false,
            queryParam: {},
            brandSel: false,
            storeSel: false,
            CurrnetMID: 0,
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            VoucherDataApi:
                config.BASE_Middle_API + 'VoucherCreate/GetCrmMutilShopData', //获取源数据接口 需提供
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            tableData: [],
            detailData: [],
            accountList: [],
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                brandId: '',
                groupType: '1'
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            let start = new Date(
                                moment()
                                    .startOf('month')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            let end = new Date(
                                moment()
                                    .endOf('days')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            multipeleSelectedIds: [],
            selOrder: [],
            selOrderIds: [],
            saveApi:
                config.BASE_Middle_API + 'VoucherCreate/MutilShopsCrmDataHandle'
        }
    },
    props: {
        tabType: {
            type: String,
            required: true
        }
    },
    components: { pagerBar, crmStep },
    mounted() {
        this.getModules()
    },
    methods: {
        deleteRow(index, id) {
            const _this = this
            _this
                .$confirm('确定删除该明细吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    _this.deleteInfo(index, id)
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        deleteInfo(index, id) {
            const _this = this
            let deleteEntity = {}
            deleteEntity.tempId = id
            deleteEntity.brandId = _this.voucherQueryModel.brandId
            if (id != undefined && id != null && id != '' && id != 0) {
                AjaxHelper.delete(_this.DeleteFiltersUrl, deleteEntity).then(
                    function (r) {
                        if (r.success) {
                            _this.deleteTip(index)
                        }
                    }
                )
            } else {
                _this.deleteTip(index)
            }
        },
        deleteTip(index) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.filtersData.splice(index, 1)
        },
        //保存
        saveFilterData() {
            const _this = this
            let num = 1
            _this.openloadingHander()
            if (_this.filtersData == null || _this.filtersData.length == 0) {
                this.$notify({
                    title: '提示',
                    message: '无待保存数据',
                    position: 'bottom-right'
                })
                _this.closeloadingHander()
                return
            }
            _this.filtersData.forEach((item) => {
                let detailParams = []
                _this.fieldList.forEach((detailParamItemBase) => {
                    if (item[detailParamItemBase.fieldName + '字段']) {
                        detailParams.push({
                            fieldName: detailParamItemBase.fieldName,
                            type: item[detailParamItemBase.fieldName + '字段'],
                            oper: item[detailParamItemBase.fieldName + '操作'],
                            value: item[detailParamItemBase.fieldName + '值']
                        })
                    }
                })
                item.tempId = item._id
                item.index = num
                item.detailParams = JSON.stringify(detailParams)
                num = num + 1
                item.brandId = _this.voucherQueryModel.brandId
                item.ModuleMark = 'CRM'
            })
            AjaxHelper.post(_this.SaveFiltersUrl, _this.filtersData)
                .then(function (response) {
                    if (response.success) {
                        _this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                        _this.initFiltersData()
                        _this.closeloadingHander()
                    }
                })
                .catch(function (error) {})
        },
        initFiltersData() {
            const _this = this
            _this.filtersData = []
            AjaxHelper.get(_this.GetFiltersDataUrl, {
                brandId: _this.voucherQueryModel.brandId,
                ModuleMark: 'CRM'
            }).then(function (response) {
                if (response.success) {
                    _this.filtersData = response.result
                    _this.setData()
                }
            })
        },
        setData() {
            const _this = this
            if (_this.filtersData != null && _this.filtersData.length > 0) {
                _this.filtersData.forEach((f) => {
                    if (f.detailParams != null && f.detailParams.length > 0) {
                        var detailParams = JSON.parse(f.detailParams)
                        detailParams.forEach((d) => {
                            f[d.fieldName] = d.fieldName
                            f[d.fieldName + '字段'] = d.type
                            f[d.fieldName + '操作'] = d.oper
                            f[d.fieldName + '值'] = d.value
                        })
                    }
                })
                _this.filtersData = JSON.parse(
                    JSON.stringify(_this.filtersData)
                )
            }
        },
        addFilters() {
            const _this = this
            _this.filtersData.push({})
        },
        ///过滤关键字
        SetFilters() {
            const _this = this
            _this.SetFiltersVisible = true
            _this.openloadingHander()
            _this.initFiltersData()
            _this.closeloadingHander()
        },

        openloadingHander() {
            this.openloading = true
        },
        closeloadingHander() {
            this.openloading = false
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                }
            )
        },
        gobalClick() {
            // 点击空白处隐藏弹窗方法
            this.sublistShow = false
        },
        clickRow(row, column, event) {
            event.stopPropagation()
            this.detailData = row.payTypes
            this.sublistShow = true
            //点击空白处关闭弹窗
        },
        selfShow(e) {
            e.stopPropagation()
            this.sublistShow = true
        },
        closeSub(e) {
            //关闭右侧弹窗
            e.stopPropagation()
            this.sublistShow = false
        },
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.closeloadingHander()
        },

        search(isAgainPull) {
            const _this = this

            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            let confirmData = Object.assign(
                { tick: _this.queryTick },
                _this.voucherQueryModel
            )
            _this.openloadingHander()
            let shopCodeList = []
            let storeIdList = []
            _this.voucherQueryModel.store.forEach((t) => {
                if (t != '全选') {
                    const storeItem = _this.storesList.filter((x) => x.id == t)
                    shopCodeList.push(storeItem[0].storeCode)
                    storeIdList.push(t)
                }
            })

            _this.loadingText = '加载中'
            confirmData.isAgainPull = isAgainPull
            confirmData.shopCodes = shopCodeList.join(',')
            confirmData.store = []
            confirmData.storeIDs = []
            _this.queryParam = Object.assign({}, confirmData)
            _this.voucherQueryModel.storeIDs = storeIdList
        },
        voucherCreateShow() {
            const _this = this
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            _this.loadingText = '加载中'
            // _this.openloadingHander()
            //凭证生成接口
            const confirmData = {
                brandID: _this.queryParam.brandId,
                shopCodes: _this.queryParam.storeCodes,
                startTime: _this.queryParam.startTime,
                endTime: _this.queryParam.endTime,
                storeIDs: _this.voucherQueryModel.storeIDs,
                groupType: _this.voucherQueryModel.groupType
            }
            _this.step2errormsg = []
            _this.Visible = false
            var totalCount = 0
            totalCount = _this.$refs.refPagerBar.pagerTotal
            let shopNameList = []
            _this.voucherQueryModel.store.forEach((t) => {
                if (t != '全选') {
                    const storeItem = _this.storesList.filter((x) => x.id == t)
                    shopNameList.push(storeItem[0].name)
                }
            })
            confirmData.storeNames = shopNameList.join(',')
            let saveData = Object.assign({ tick: _this.queryTick }, confirmData)
            let queryDatas = Object.assign({}, saveData)
            _this.$refs.voucherCreateStep.showParams(queryDatas)
            _this.$refs.voucherCreateStep.beginStep(queryDatas, totalCount)

            AjaxHelper.post(
                config.BASE_Middle_API +
                    'VoucherCreate/CheckCrmErrorBasicDatas',
                queryDatas
            )
                .then(function (response) {
                    if (response.result.length > 0) {
                        _this.$refs.voucherCreateStep.failstep1(response.result)
                    } else {
                        _this.$refs.voucherCreateStep.successstep1(totalCount)
                        AjaxHelper.post(_this.saveApi, queryDatas)
                            .then(function (response) {
                                if (response.result.isSuccess) {
                                    _this.$refs.voucherCreateStep.successstep2()
                                } else {
                                    _this.$refs.voucherCreateStep.failstep2(
                                        response.result.voucherHandleInfos
                                    )
                                }
                                _this.targetData = []
                            })
                            .catch(function (error) {
                                _this.$refs.voucherCreateStep.failstep2(
                                    error.message
                                )
                                _this.closeloadingHander()
                            })
                    }
                })
                .catch(function (error) {
                    _this.$refs.voucherCreateStep.errorstep1(error.message)
                    _this.closeloadingHander()
                })

            // AjaxHelper.post(
            //     _this.VoucherCreateApi + '/MutilShopsCrmDataHandle',
            //     queryDatas
            // )
            //     .then(function (response) {
            //         if (response.result.voucherHandleInfos.length > 0) {
            //             _this.Visible = true
            //             _this.step2errormsg = response.result.voucherHandleInfos
            //             // {
            //             //     _this.$notify({
            //             //         title: "提示",
            //             //         message: response.result.successMsg,
            //             //         type: "success",
            //             //         position: "bottom-right",
            //             //         duration: 0,
            //             //     });
            //             // }
            //             // } else {
            //             //     _this.$notify({
            //             //         title: "提示",
            //             //         message: response.result.errorMsg,
            //             //         type: "error",
            //             //         position: "bottom-right",
            //             //         duration: 0,
            //             //     });
            //             // }
            //         }
            //         _this.closeloadingHander()
            //     })
            //     .catch(function (error) {
            //         _this.closeloadingHander()
            //     })
        },
        getAccount() {},
        getTableData(d) {
            const _this = this
            _this.tableData = d
            //查询无结果 不允许生成凭证
            if (d.length > 0) {
                _this.isSearchVal = true
            } else {
                _this.isSearchVal = false
            }

            _this.closeloadingHander()
        },

        storeChange(val) {
            this.storeSel = true
            var end = val[val.length - 1]
            if (
                !val.includes('全选') &&
                val.length === this.storesList.length
            ) {
                val.unshift('全选')
            } else if (val.includes('全选') && val.length == 1) {
                this.storesList.map((item) => {
                    val.push(item.id)
                })
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length &&
                end == '全选'
            ) {
                val = []
                this.storesList.map((item) => {
                    val.push(item.id)
                })
                val.unshift('全选')
                // this.value = val;
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length
            ) {
                val = val.filter((item) => {
                    return item !== '全选'
                })
                // this.value = val;
            }
            // 注意，加上  this.value = val，确保勾选值同步
            this.voucherQueryModel.store = val
        },
        brandChange(val) {
            this.brandSel = true
            this.isSearchVal = false
            this.storeSel = false
            this.voucherQueryModel.store = ''
            this.storesList = this.stores.filter((x) => x.brandID === val)
        },
        removeTag(val) {
            if (val === '全选') {
                this.voucherQueryModel.store = []
                this.tableData = []
            }
            if (this.voucherQueryModel.store.length == 0) {
                this.isSearchVal = false
            }
        },
        statusSearch(item) {
            this.storeSel = false
            //this.brandSel = false;
            this.CurrnetMID = item.id
            this.voucherQueryModel.brandId = ''
            this.voucherQueryModel.store = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            this.isSearchVal = false
        },
        getModules() {
            const _this = this
            this.openloadingHander()
            AjaxHelper.get(
                _this.VoucherCreateApi + '/GetModules?tabType=' + _this.tabType
            )
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            _this.brands.forEach((x) => {
                                _this.moduleList.forEach((element) => {
                                    if (element.id == x.moduleID) {
                                        // x.name = element.name + "/" + x.name;
                                        _this.brandList.push(x)
                                    }
                                })
                            })
                        }
                    }
                    _this.closeloadingHander()
                })
                .catch(function (error) {
                    _this.closeloadingHander()
                })
        },
        pickerOptions2() {},
        initData() {},

        handleClose(done) {
            this.isVoucherCreate = false
            done()
        }
    }
}
</script>

<style scoped>
.text-wrapper {
    word-wrap: break-word;
    word-break: break-all;
}
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
.subname-enter-active,
.subname-leave-active {
    transition: opacity 0.6s;
}
/*指定隐藏时的样式*/

.subname-enter,
.subname-leave-to {
    opacity: 0;
}

.subCard {
    position: absolute;
    z-index: 2900;
    width: 55%;
    right: 0;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px);
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
